import { usePersistedQuery } from "@/features/order-sheet-sets/hooks/use-persisted-query";
import { StringTransformer } from "@/features/ui/helpers/string-transformer";

export type PersistedLineSheetSetDetailPageQuery = {
  referer?: string;
  orderSheetSetId?: number;
  pageSize?: number;
  pageNumber?: number;
  "madeByCompany.id__in"?: number[];
  season__in?: string[];
  query?: string;
};

export default function usePersistedLineSheetSetDetailPageQuery() {
  const { value, set, clear } =
    usePersistedQuery<PersistedLineSheetSetDetailPageQuery>({
      entries: {
        referer: {
          parse: StringTransformer.parseString,
          stringify: StringTransformer.stringifyString,
        },
        orderSheetSetId: {
          parse: StringTransformer.parseId,
          stringify: StringTransformer.stringifyId,
        },
        pageSize: {
          parse: StringTransformer.parseNumber,
          stringify: StringTransformer.stringifyId,
        },
        pageNumber: {
          parse: StringTransformer.parseNumber,
          stringify: StringTransformer.stringifyNumber,
        },
        "madeByCompany.id__in": {
          parse: StringTransformer.parseIds,
          stringify: StringTransformer.stringifyIds,
        },
        season__in: {
          parse: StringTransformer.parseStrings,
          stringify: StringTransformer.stringifyStrings,
        },
        query: {
          parse: StringTransformer.parseString,
          stringify: StringTransformer.stringifyString,
        },
      },
    });

  return {
    value,
    set,
    clear,
  };
}
